import React, { Component } from 'react'
import { Button, Form, Input, Select, message, Spin, Slider, InputNumber, Table, Tooltip } from 'antd'
import { Link } from 'dva/router'
import NumberFormat from 'react-number-format'
import {connect} from 'dva'
import { all, create, get, update, remove } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

class ISR extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            isr: [],
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        /*if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/

        if (this.props.incomeType === 'cash_funds_trie' || this.props.incomeType === 'others_trie' || this.props.incomeType === 'payroll_trie')
            this.state = {...this.state, currentHotel: null};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        this.firstLoad();
    }


    /**
    * Consulta los registros
    */
    firstLoad () {
        this.props.dispatch({type: 'app/showLoadingTable'})

        all('ISR', {limit: 1000}).then((resp) => {

            this.props.dispatch({type: 'app/hideLoadingTable'})
            this.setState({ isr: resp.results });
        });
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.-]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    } 


    /**
    * Envío del formulario
    */
    updateISR (item) {

        // Model
        let data = {...item};
        data.percent = this.props.form.getFieldValue(item.objectId + '_percent');

        if (this.props.form.getFieldValue(item.objectId + '_inferior_limit'))
            _.isNumber(this.props.form.getFieldValue(item.objectId + '_inferior_limit')) ? data.inferior_limit = this.props.form.getFieldValue(item.objectId + '_inferior_limit') : data.inferior_limit = Number(this.props.form.getFieldValue(item.objectId + '_inferior_limit').replace(/[^\d.-]/g, ''))
        else
            data.inferior_limit = 0;


        if (this.props.form.getFieldValue(item.objectId + '_superior_limit'))
            _.isNumber(this.props.form.getFieldValue(item.objectId + '_superior_limit')) ? data.superior_limit = this.props.form.getFieldValue(item.objectId + '_superior_limit') : data.superior_limit = Number(this.props.form.getFieldValue(item.objectId + '_superior_limit').replace(/[^\d.-]/g, ''))
        else
            data.superior_limit = 0;


        if (this.props.form.getFieldValue(item.objectId + '_fee'))
            _.isNumber(this.props.form.getFieldValue(item.objectId + '_fee')) ? data.fee = this.props.form.getFieldValue(item.objectId + '_fee') : data.fee = Number(this.props.form.getFieldValue(item.objectId + '_fee').replace(/[^\d.-]/g, ''))
        else
            data.fee = 0;

        data = _.omit(data, ['createdAt', 'updatedAt']);

        this.props.dispatch({type: 'app/showButtonLoading'})
        this.props.dispatch({type: 'app/showLoadingTable'})

        update('ISR', data.objectId, data).then(resp => {

            this.props.dispatch({type: 'app/hideButtonLoading'})
            this.props.dispatch({type: 'app/hideLoadingTable'})

            message.success('Se ha actualizado el registro exitosamente');

        }).catch(e => {
            this.props.dispatch({type: 'app/hideButtonLoading'})
            this.props.dispatch({type: 'app/hideLoadingTable'})

            if (e && e.data) message.error(e.data.error);
            else message.error('Ha ocurrido un error. Intente más tarde')    
        });
    }


    /**
    * Render del componente
    */
    render () {
        return (
            <Form>
                <div className="row">
                    <Spin spinning={this.props.app.loadingTable}>
                        <div className="col-md-12">
                            <Table 
                                dataSource={this.state.isr} 
                                rowKey="objectId" 
                                size="middle" 
                                pagination={false} >

                                <Column title="Límite Inferior" key="inferior_limit" render={(item) => (
                                    <FormItem style={{margin: 0}}>
                                        {this.props.form.getFieldDecorator(item.objectId + '_inferior_limit', {
                                            initialValue: item.inferior_limit,
                                            rules: [{}, {
                                                validator: this.checkAmount.bind(this)
                                            }]
                                        })(
                                            <NumberFormat 
                                                thousandSeparator={true} 
                                                prefix={'$'} 
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                )}/>

                                <Column title="Límite Superior" key="superior_limit" render={(item) => (
                                    <FormItem style={{margin: 0}}>
                                        {this.props.form.getFieldDecorator(item.objectId + '_superior_limit', {
                                            initialValue: item.superior_limit,
                                            rules: [{}, {
                                                validator: this.checkAmount.bind(this)
                                            }]
                                        })(
                                            <NumberFormat 
                                                thousandSeparator={true} 
                                                prefix={'$'} 
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                )}/>

                                <Column title="Cuota" key="fee" render={(item) => (
                                    <FormItem style={{margin: 0}}>
                                        {this.props.form.getFieldDecorator(item.objectId + '_fee', {
                                            initialValue: item.fee
                                        })(
                                            <NumberFormat 
                                                thousandSeparator={true} 
                                                prefix={'$'} 
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                )}/>

                                <Column title="Porcentaje" key="percent" render={(item) => (
                                    <FormItem style={{margin: 0}}>
                                        {this.props.form.getFieldDecorator(item.objectId + '_percent', {
                                            initialValue: item.percent
                                        })(
                                            <InputNumber 
                                                min={0} 
                                                max={100} 
                                                formatter={value => `${value}%`}
                                                parser={value => value.replace('%', '')} 
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                )}/>

                                <Column title="Acciones" key="action" width={90}
                                    render={(item) => (
                                        <span className="actions">
                                            <ButtonGroup>
                                                <Tooltip placement="bottom" title="Actualizar">
                                                    <Button>
                                                        <Link onClick={() => { this.updateISR(item) }}><Icon name="save" /></Link>
                                                    </Button>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </span>
                                    )}
                                />
                            </Table>  
                        </div>
                    </Spin>
                </div>
            </Form>
        )
    }
}

ISR.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({income, app}) => ({income, app}))(Form.create()(ISR))


// WEBPACK FOOTER //
// ./src/components/config/isr.js